import React from 'react';
import styles from './client-tab.styles.css';

export default function ClientTab(props) {
  const { tab, active } = props;

  return (
    <a className={`${styles.tab}`} href={tab.url}>
      <span className={`${styles.text} ${active ? styles.active : ''}`}>
        {tab.name}
      </span>
    </a>
  );
}
